import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";
import { useAppMode } from "@/context/AppModeContext";
import { usePlayBilling } from "@/hooks/usePlayBilling";

/**
 * Silent one-shot restore for the Android TWA.
 *
 * When the app is opened inside Google Play (Digital Goods API present), the
 * signed-in user is not Premium, we ask Play for owned purchases and send them
 * to the backend for verification. The backend decides; nothing is trusted
 * from localStorage or the client. Renders nothing.
 */
export function PlayBillingAutoRestore() {
  const { user } = useAuth();
  const { isAppMode } = useAppMode();
  const { supported, restore } = usePlayBilling({ enabled: false });
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    if (!user || user.is_premium) return;
    if (!supported || !isAppMode) return;
    ranRef.current = true;
    restore({ silent: true }).catch(() => {});
  }, [user, supported, isAppMode, restore]);

  return null;
}
